<template>
  <b-card class="main-balance-card" no-body>
    <b-card-body>
      <b-card-title class="dark-variant">
        Main Balance
        <CurrencySelector
          v-model="displayCurrency"
          compact
          class="mb-currency"
          @change="onCurrencyChange"
        />
      </b-card-title>
      <div class="main-balance-info">
        <b-card-text>
          <p>Available Balance :</p>
          <p v-if="showsEquivalent">Equivalent :</p>
          <p>Amej Coin :</p>
          <p>Today's Rate</p>
        </b-card-text>
        <b-card-text class="dark-variant">
          <p>US$ {{ formatBalance(profile.coins) }}</p>

          <!-- The wallet is held in USD; this is a display conversion at the mid rate,
               not a quote. A real conversion is priced by the server with markup. -->
          <p v-if="showsEquivalent" class="mb-equivalent">
            {{ equivalentText }}
          </p>

          <p v-if="profile.rate">
            {{ formatMoney(coinsToBalance(profile.coins) * (profile.rate ? profile.rate.buy : 0)) }}
            <span class="coin">Coin</span>
          </p>
          <p v-if="showsEquivalent" class="mb-rate">1 USD = {{ rateText }}</p>
          <p v-else-if="profile.rate">$ 1 = {{ formatMoney(profile.rate.buy) }} Coin</p>
        </b-card-text>
      </div>
      <small class="mb-note" v-if="showsEquivalent">
        Indicative rate for display. Conversions are priced at confirmation.
      </small>
    </b-card-body>
  </b-card>
</template>
<script>
import { formatBalance, formatMoney, coinsToBalance } from "@/utils/format";
import {
  convert, formatCurrency, formatRate, findRate,
  getDisplayCurrency, setDisplayCurrency, hasDisplayCurrency, BASE_CURRENCY,
} from "@/utils/currency";
import CurrencySelector from "../reuseable_components/CurrencySelector.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "MainBalance",
  components: { CurrencySelector },
  data() {
    return {
      // Falls back to the account's default_currency, then USD.
      displayCurrency: getDisplayCurrency(BASE_CURRENCY),
    };
  },
  computed: {
    ...mapState(["profile", "currencies"]),
    balanceUsd: function () {
      return coinsToBalance(this.profile && this.profile.coins);
    },
    /** Nothing to show when the display currency IS the base. */
    showsEquivalent: function () {
      return this.displayCurrency &&
             this.displayCurrency !== BASE_CURRENCY &&
             Boolean(findRate(this.currencies, this.displayCurrency));
    },
    equivalentText: function () {
      const value = convert(this.currencies, this.balanceUsd, BASE_CURRENCY, this.displayCurrency);
      if (value === null) { return ""; }
      return formatCurrency(this.currencies, value, this.displayCurrency);
    },
    rateText: function () {
      const row = findRate(this.currencies, this.displayCurrency);
      if (!row) { return ""; }
      const r = (row.buy !== undefined && row.buy !== null) ? row.buy : row.rate;
      // formatRate, not formatCurrency: a JPY rate rendered with the currency's own
      // zero decimals reads "1 USD = 159" and throws away real precision.
      return formatRate(this.currencies, r, this.displayCurrency);
    },
  },
  created() {
    this.listProfile();
    // Cached for 24h, so this is usually free.
    this.listCurrencies();
  },
  watch: {
    // Adopt the account's default currency the first time the profile arrives, unless
    // the person has already chosen something to view in.
    profile: function () {
      const author = (this.profile && this.profile.author) || {};
      if (!hasDisplayCurrency() && author.default_currency) {
        this.displayCurrency = author.default_currency;
      }
    },
  },
  methods: {
    ...mapActions(["listProfile", "listCurrencies"]),
    formatBalance: formatBalance,
    formatMoney: formatMoney,
    coinsToBalance: coinsToBalance,
    onCurrencyChange: function (code) {
      this.displayCurrency = code;
      setDisplayCurrency(code);
      // Other cards on the page follow the same choice.
      this.$root.$emit("display-currency-changed", code);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../../css/style.scss";
</style>
<style scoped>
.main-balance-card .card-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.mb-currency { margin-left: auto; }
.mb-equivalent { font-weight: 600; color: #0066b3; }
.mb-rate { font-size: 13px; color: #6b7280; }
.mb-note { display: block; margin-top: 8px; font-size: 11px; color: #8a94a6; }
</style>
